import domready from 'domready';
import { TOUJOU_EVENT_CONTACT_DIALOG_OPEN } from '../utils/constants';

/**
 * A class that handles the toggle button for opening the contact dialog
 * in the top bar. Dispatches a custom event when clicked.
 */
class TopbarContactToggle {
  /**
   * @param {HTMLButtonElement} toggle - The toggle button element
   */
  constructor(toggle) {
    /** @type {HTMLButtonElement} */
    this.toggle = toggle;

    this._onClick = this._onClick.bind(this);
    this.toggle.addEventListener('click', this._onClick);
  }

  /**
   * Handles click events on the toggle and dispatches a custom event.
   * @private
   */
  _onClick() {
    this.toggle.dispatchEvent(new CustomEvent(TOUJOU_EVENT_CONTACT_DIALOG_OPEN, {
      bubbles: true,
      composed: true,
    }));
  }
}

/**
 * Initializes the top bar contact toggle if it exists on the page.
 * Prevents multiple initializations using a custom instance property.
 */
function initTopbarContactToggle() {
  /** @type {HTMLButtonElement|null} */
  const topbarContactToggle = document.querySelector('.topbar-contact__toggle');
  if (!topbarContactToggle) return;

  if (!topbarContactToggle.topbarContactToggleInstance) {
    topbarContactToggle.topbarContactToggleInstance = new TopbarContactToggle(topbarContactToggle);
  }
}

// Initialize when DOM is ready
domready(() => {
  initTopbarContactToggle();
});
